export default __webpack_public_path__ + "static/media/feb2024-1.8c2c400c.jpg";